// extracted by mini-css-extract-plugin
module.exports = {"container":"faq_container__2LL13","wrapper":"faq_wrapper__2_nUw"};